'use strict';

angular.module('amexReconciliationApp')
  .directive('validateNumber',
  function validateNumber(ValidationService) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elm, attrs, ngModel) {
        ngModel.$validators.number = function (modelValue, viewValue) {
          return ValidationService.isValidPercentage(viewValue);
        };
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/validateNumber.js
// module id = 545
// module chunks = 0